import { useContext, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import {
  FilterContext,
  Flex,
  Icon,
  Select,
  Button,
} from 'dash-ui';

import { useGetCurrentDeveloperPropertiesQuery } from 'gql/generated.graphql';

import TimeRangeDropdown from './components/TimeRangeDropdown';
import { FlexWraper, IconWraper } from 'pages/Dashboard/components/DashboardFilters/DashboardFilters.style';

const DashboardFilters = () => {
  const { t } = useTranslation(['common', 'pages']);
  const { setFilterState, state: filterState } = useContext(FilterContext);
  const { data, loading } = useGetCurrentDeveloperPropertiesQuery();

  const propertiesOptions = useMemo(() => {
    const properties = data?.getCurrentDeveloperProperties.collection || [];

    return properties.map((property) => ({
      label: property.name,
      value: property._id,
    }));
  }, [data]);

  useEffect(() => {
    setFilterState(
      'propertyId',
      propertiesOptions[0] ? propertiesOptions[0].value : ''
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [propertiesOptions]);

  return (
    <FlexWraper>
      {/* <Button
        icon="download"
        variation="flat"
        iconProps={{ size: 20 }}
        whiteSpace="nowrap"
      >
        {t('pages:organizationDashboardPage.exportData')}
      </Button> */}
      <Flex w={["100%", 200, 200, 200]} justifyContent="space-between">
        <IconWraper variation="outline">
          <Icon
            size={22}
            name="calendarToday"
          />
        </IconWraper>
        <TimeRangeDropdown filterState={filterState} />
      </Flex>
      <Flex w={["100%", 200, 200, 200]} justifyContent="space-between">
       <IconWraper variation="outline">
        <Icon
          size={22}
          name="domain"
        />
      </IconWraper>
      <Select
        w="100%"
        withCheckbox={false}
        isSearchable={false}
        isButtonSelect
        strictMenuWidth
        buttonSelectType="button"
        isLoading={loading}
        value={filterState.propertyId}
        options={propertiesOptions}
        placeholder={
          propertiesOptions.find(
            (item) => item.value === filterState.propertyId
          )?.label
        }
        onChanged={(value) => setFilterState('propertyId', value)}
      />
      </Flex>
    </FlexWraper>
  );
};

export default DashboardFilters;
